

import accordion from "./components/accordion"
import equalize from "./components/equalize"

import fonticons from "./components/fonticons"
import iconHover from "./components/icon-hover"
// import margins from "./components/margins"
import mobileMenu from "./components/mobile"
import modals from "./components/modals"
// import paddings from "./components/paddings"
import sticky from "./components/sticky"




document.addEventListener('DOMContentLoaded',(event)=>{
   fonticons() // fontawesome
   mobileMenu() // initiate mobile menu
   modals() // modals
   sticky()
   accordion()
   iconHover()
  equalize()
  //  paddings()
  //  margins()
   history.scrollRestoration = "manual";
  

})
//  window.onbeforeunload = function () {
//       window.scrollTo(0, 0);
//     }
window.isMobile = ()=>{
   try{ document.createEvent("TouchEvent"); return true; }
   catch(e){ return false; }
 }

window.debounce = (func, wait = 20, immediate = true) => {
   var timeout;
   return function() {
     var context = this, args = arguments;
     var later = function() {
       timeout = null;
       if (!immediate) func.apply(context, args);
     };
     var callNow = immediate && !timeout;
     clearTimeout(timeout);
     timeout = setTimeout(later, wait);
     if (callNow) func.apply(context, args);
   };
 };

